function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconTwitter = function IconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "89",
    height: "100",
    viewBox: "0 0 89 100",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M68.8626 96.5392L2.86777 1.5H18.3923L84.3871 96.5392H68.8626Z",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4716_16016",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7255 0H85.7843L49.2516 42.5868L50.5691 44.4795L88.7255 0ZM39.7445 57.0978L38.427 55.205L0 100H2.94118L39.7445 57.0978Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7255 0H85.7843L49.2516 42.5868L50.5691 44.4795L88.7255 0ZM39.7445 57.0978L38.427 55.205L0 100H2.94118L39.7445 57.0978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7843 0V-1H85.3246L85.0253 -0.651098L85.7843 0ZM88.7255 0L89.4845 0.651098L90.9009 -1H88.7255V0ZM49.2516 42.5868L48.4926 41.9357L47.9887 42.523L48.4308 43.1581L49.2516 42.5868ZM50.5691 44.4795L49.7483 45.0508L50.4866 46.1115L51.3281 45.1306L50.5691 44.4795ZM39.7445 57.0978L40.5035 57.7489L41.0074 57.1616L40.5653 56.5265L39.7445 57.0978ZM38.427 55.205L39.2478 54.6337L38.5095 53.5731L37.668 54.554L38.427 55.205ZM0 100L-0.758994 99.3489L-2.17538 101H0V100ZM2.94118 100V101H3.40087L3.70017 100.651L2.94118 100ZM85.7843 1H88.7255V-1H85.7843V1ZM50.0106 43.2378L86.5433 0.651098L85.0253 -0.651098L48.4926 41.9357L50.0106 43.2378ZM48.4308 43.1581L49.7483 45.0508L51.3898 43.9082L50.0723 42.0154L48.4308 43.1581ZM87.9665 -0.651098L49.8101 43.8284L51.3281 45.1306L89.4845 0.651098L87.9665 -0.651098ZM40.5653 56.5265L39.2478 54.6337L37.6063 55.7763L38.9238 57.6691L40.5653 56.5265ZM0.758994 100.651L39.186 55.8561L37.668 54.554L-0.758994 99.3489L0.758994 100.651ZM2.94118 99H0V101H2.94118V99ZM38.9855 56.4467L2.18218 99.3489L3.70017 100.651L40.5035 57.7489L38.9855 56.4467Z",
    fill: "currentColor",
    mask: "url(#path-2-inside-1_4716_16016)"
  }));
};